import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../store/user-slice";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { notificationActions } from "../store/notification-slice";
import Backdrop from "./Backdrop";
import useAuthorized from "../hook/useAuthorized";
import Skeleton from "react-loading-skeleton";
import { useOrder } from "../hook/useOrder";
import AppNotification from "./AppNotification";

export default function DefaultLayout() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  let dispatch = useDispatch();

  let navigate = useNavigate();
  const location = useLocation();

  let notification = useSelector((state) => state.notification.notification);

  const { isAdmin, isAuthorized } = useAuthorized();

  const {getCartItems}=useOrder()

 

  useEffect(() => {
    if (isAuthorized !== null && isAdmin !== null) {
      if (!isAuthorized) {
        dispatch(userActions.setUser(null));
        navigate("/login");
      }

      if (notification) {
        setTimeout(() => {
          dispatch(notificationActions.setNotification(null));
        }, 3000);
      }

      dispatch(userActions.setIsAdmin(isAdmin));
      
      getCartItems()
    }
  }, [notification, isAdmin, isAuthorized]);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMobileMenuOpen) return undefined;
    const closeOnEscape = event => {
      if (event.key === "Escape") setIsMobileMenuOpen(false);
    };
    document.addEventListener("keydown", closeOnEscape);
    return () => document.removeEventListener("keydown", closeOnEscape);
  }, [isMobileMenuOpen]);



  if (isAuthorized === null || isAdmin === null ) {
    return <Skeleton count={50} />;
  }

  return (
    <div className={`app-shell bg-maryam${isMobileMenuOpen ? " mobile-menu-open" : ""}`}>
      <Sidebar isOpen={isMobileMenuOpen} onClose={() => setIsMobileMenuOpen(false)} />
      <button
        type="button"
        className="mobile-menu-backdrop"
        aria-label="Close navigation"
        onClick={() => setIsMobileMenuOpen(false)}
      />
      <div className="app-content">
        <Header onMenuToggle={() => setIsMobileMenuOpen(open => !open)} isMenuOpen={isMobileMenuOpen} />
        <main className="default-layout">
          <Outlet />
        </main>
      </div>

      <AppNotification notification={notification} aboveNavigation />

      <Backdrop />
    </div>
  );
}
